import { ConfigBarChartForm } from '@pages/DiagramsCreateOrEdit/types'

import { axisXOptions, FORMATS_DATE_OPTIONS, incrementOptions, periodOptions } from '@constants'

export const getDefaultValues = (): ConfigBarChartForm => {
  return {
    timeline: {
      axisX: axisXOptions[0],
      period: periodOptions[0],
      dateRange: ['', ''],
      timeIncrement: incrementOptions[0],
      formatDate: FORMATS_DATE_OPTIONS[1],
      series: Array.from({ length: 24 }, (_, index) => {
        const from = index
        const till = index + 1
        const title = `${String(from).padStart(2, '0')}-${String(till).padStart(2, '0')}`

        return {
          title,
          order: from,
          dateRange: { from: from.toString(), till: till.toString() },
        }
      }),
    },
    columns: [],
    resources: [],
  }
}
